import React from 'react'
import { Button, Tag, Typography } from '@surecompanies/core_components'
import { ArrowLeftOutlined } from '@ant-design/icons'
import styles from './CarrierDetail.module.scss'
import { DownloadAttemptsButton } from './DownloadAttemptsButton'

const { Title } = Typography

interface Props {
  /** Title text only. On All Carriers the API sends the synthetic label `All Carriers`. */
  displayCarrierName?: string
  botType?: string | null
  /**
   * Carrier the export filters on — the client-resolved name, not the displayed one.
   * Must stay `undefined` for All Carriers so the param is omitted and every carrier
   * is exported; passing the `All Carriers` label matches no row and yields an
   * empty, header-only file.
   */
  exportCarrierName?: string
  /** False hides Download Excel (member rows the viewer may not see). */
  showAttemptsExport?: boolean
  month: number
  year: number
  onBack: () => void
}

// Carrier-detail header: back-to-summary button + carrier title + bot-type tag.
export function CarrierDetailHeader({
  displayCarrierName,
  botType,
  exportCarrierName,
  showAttemptsExport = true,
  month,
  year,
  onBack,
}: Props) {
  return (
    <div className={styles.header}>
      <div className={styles.headerLeft}>
        <Button
          icon={<ArrowLeftOutlined />}
          onClick={onBack}
          data-testid="carrier-detail-back"
        >
          Back
        </Button>
        <div className={styles.titleRow}>
          <Title level={4} className={styles.carrierTitle}>
            {displayCarrierName}
          </Title>
          {botType && (
            <Tag color="blue" className={styles.botTypeTag}>
              {botType}
            </Tag>
          )}
        </div>
      </div>
      {showAttemptsExport && (
        <DownloadAttemptsButton
          carrierName={exportCarrierName}
          month={month}
          year={year}
        />
      )}
    </div>
  )
}
